import { Controller } from "@hotwired/stimulus"
import { findRow, revealRow } from "../lib/interaction_pages"

const ROW_ID = /^interaction_\d+(_row)?$/

// Scrolls to the row the URL's anchor names (#interaction_12_row) when it sits
// on a page that has not loaded yet. Turbo scrolls to anchors as it renders,
// so it finds only the first page's rows; this loads the pages up to the row
// first. Turbo reports a same-page anchor visit as hashchange. A row already
// on the page is left alone, so going Back keeps the restored scroll.
export default class extends Controller {
  connect() {
    this.reveal()
  }

  async reveal() {
    const id = location.hash.slice(1)
    if (!ROW_ID.test(id) || findRow(id)) return

    const row = await revealRow(id)
    row?.scrollIntoView()
  }
}
